<template>
	<div class="taskDetail">
		<div
		 class="taskDetail_inner"
		 :style="{'padding-bottom':showFormTip?'180px':'35px'}"
		>
			<div class="backButton">
				<span @click="goBack">
					<i class="back el-icon-arrow-left"></i>
					返回
				</span>
			</div>
			<div class="content_header">
				<div class="left">
					<img
					 :src="taskDetail.coverUrl"
					 class="coverUrl"
					 alt=""
					/>
				</div>
				<div class="right">
					<div class="right_up">
						<div class="name">
							{{ taskDetail.name }}
						</div>
						<ul class="tag">
							<li
							 v-for="item in taskDetail.taskItemTypeList"
							 :key="item.type"
							>
								<span>{{ tag[item.type] }}：</span>
								<span>{{ item.count }}</span>
							</li>
						</ul>
					</div>
					<div class="right_down">
						<div
						 class="expired"
						 v-show="$route.query.validity === '' || $route.query.validity === 'true'"
						>
							<span class="expiredKey">任务周期：</span>
							<span
							 class="expiredVal"
							 v-if="taskDetail.cycleType === 1"
							>{{ taskDetail.startTime.split(' ')[0].replace(/-/g, '.') }} 至 {{ taskDetail.endTime.split(' ')[0].replace(/-/g, '.') }}</span>
							<span
							 class="expiredVal"
							 v-if="taskDetail.cycleType === 2"
							>有效期至：{{ taskDetail.endTime.split(' ')[0].replace(/-/g, '.') }}</span>
							<span
							 class="expiredVal"
							 v-if="taskDetail.cycleType === 3"
							>长期有效</span>
						</div>
					</div>
				</div>
				<div class="status">
					<svg-icon
					 v-if="!taskDetail.studyProcess"
					 icon-class="jinxingzhong"
					></svg-icon>
					<svg-icon
					 v-else-if="taskDetail.studyProcess === 100"
					 icon-class="jinxingzhong"
					></svg-icon>
					<svg-icon
					 v-else
					 icon-class="jinxingzhong"
					></svg-icon>
				</div>
			</div>
			<div class="content_body">
				<div class="tabs">
					<span
					 :class="{ isActive: !isCatalog }"
					 @click="isCatalog = false"
					>简介</span>
					<span
					 :class="{ isActive: isCatalog }"
					 @click="isCatalog = true"
					>目录</span>
				</div>
				<div class="inner">
					<!-- 培训任务根节点直接挂载  课程、考试、直播、实训、表单 -->
					<div
					 class="list"
					 v-if="isCatalog"
					>
						<!-- 有直播任务时提示 -->
						<div
						 class="zb-tip"
						 v-if="isHaveLive"
						>
							建议使用Chrome浏览器/360极速浏览器。
						</div>

						<TaskItem
						 :taskDetail="taskDetail"
						 :taskCatalogList="taskDetail.taskItemVoList"
						></TaskItem>
					</div>

					<div
					 class="taskDesc"
					 v-else
					 v-html="taskDetail.description"
					></div>
				</div>
			</div>
		</div>
		<bottomFixedformTip v-if="showFormTip" @toInputForm="toInputForm" />
	</div>
</template>
<script>
// import TaskItem from "./taskItem";
import TaskItem from "wdn-pc/src/modules/learning/page/taskItem.vue";
import bottomFixedformTip from "./components/bottom-fixedForm-tip";
// import TaskContentItem from './taskContentItem'
export default {
  name: "taskDetail",
  data() {
    return {
      taskDetail: {}, //任务详情
      tag: {
        2: "课程",
        3: "考试",
        4: "直播",
        5: "线上实训",
        6: "表单",
        7: "练习",
        8: "线下实训"
      }, //内容类型
      isCatalog: true,
      isLock: true,
      taskActiveName: "", //培训任务目录
      isFaceRecognize: null, // 是否需要人脸识别
      isHaveLive: false, //是否有直播任务,
      showFormTip: false //最底部的表单填写提示展示
    };
  },
  components: {
    TaskItem,
    bottomFixedformTip
  },
  created() {
    this.getTaskDetail();
  },
  mounted() {},
  methods: {
    goBack() {
      if (this.$route.query.backPath) {
        sessionStorage.setItem("userCenterCurrentTab", "我的学习");
        this.$router.push({
          path: this.$route.query.backPath,
          query: {
            goodsId: this.$route.query.goodsId,
            goodsKind: this.$route.query.goodsKind
          }
        });
      } else {
        this.$router.push({
          path: "/learning",
          query: {
            backModule: this.$route.query.backMoudle
          }
        });
      }
    },
    getTaskDetail() {
      const params = {
        id: this.$route.query.id || null,
        version: 1 ////兼容接口版本
      };
      this.$api.learning.taskDetail({ params }).then(res => {
        if (!res.data && res.message === "用户尚未添加到该培训任务") {
          this.$router.go(-1);
          return false;
        }
        this.taskDetail = res.data;
        this.taskDetail.taskItemVoList.length &&
          this.taskDetail.taskItemVoList.forEach(item => {
            if (item.type == 4) {
              this.isHaveLive = true;
            }
          });
        //判断最后的表单
        const lastItem = this.taskDetail.taskItemVoList[
          this.taskDetail.taskItemVoList.length - 1
        ];
        if (lastItem.type === 6) {
          this.showFormTip = !lastItem.submitStatus;
        }
      });
    },
	//去滚动到填写表单处
	toInputForm(){
		window.scroll({
			top: document.documentElement.scrollHeight,
			left: 0,
			behavior: 'smooth'
		});
	}
  }
};
</script>
<style lang="stylus" scoped src="../css/taskDetail.styl"></style>
